import { api, queryKeys, type User } from '@alpha/api-client';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useTableQuery } from '../../hooks/useTableQuery';
import { Select } from '../../ui';
import { TEAM_TABS, teamColumns } from './DirectTeam';

const LEVELS = [1, 2, 3, 4, 5, 6, 7];

export function LevelTeam() {
  // The level filter is a URL param the server reads — no client-side slicing.
  const { query, setParam, setPage } = useTableQuery({ extraParams: ['level'] });
  const level = (query.level as string | undefined) ?? '1';

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.team('level', query),
    queryFn: () => api.team.level(query),
  });

  const columns = useMemo(() => teamColumns, []);

  return (
    <>
      <PageHeader
        title="Level Team"
        description="Your sponsor tree across the seven income-bearing levels."
        tabs={TEAM_TABS}
      />

      <DataTable<User>
        title={`Level ${level}`}
        columns={columns}
        data={data?.data}
        meta={data?.meta}
        isLoading={isLoading}
        error={error as Error | null}
        emptyLabel={`No members at level ${level}`}
        onPageChange={setPage}
        toolbar={
          <Select value={level} onChange={(e) => setParam('level', e.target.value)}>
            {LEVELS.map((l) => (
              <option key={l} value={l}>
                Level {l}
              </option>
            ))}
          </Select>
        }
      />
    </>
  );
}
